// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"91f159ec","96":"34b6420f","233":"669b6c16","453":"aefd2f63","469":"7df4bcb9","532":"ab1bcb2c","731":"510f57b2"}[chunkId] + ".chunk.js";
};